import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClipboard2Sparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M17 4H21V15.6084L20.5596 15.4395L19.4307 12.5H16.5693L15.4395 15.4395L12.5 16.5693V19.4307L15.4395 20.5596L15.9932 22H3V4H7V2H17V4ZM8.5 6.5H15.5V3.5H8.5V6.5Z" fill="currentColor"/><Path d="M19.4004 16.5996L22 17.5996V18.4004L19.4004 19.4004L18.4004 22H17.5996L16.5996 19.4004L14 18.4004V17.5996L16.5996 16.5996L17.5996 14H18.4004L19.4004 16.5996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2Sparkle;
